import { topicsItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              话题广场
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600">
              热门话题标签聚合，找到你最想吃的瓜
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topicsItems.map((topic) => (
              <a
                key={topic.id}
                href="#index"
                className="group inline-flex flex-col items-center px-5 py-3.5 bg-background-100 hover:bg-primary-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer min-w-[120px]"
              >
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {topic.hot && (
                    <span className="inline-block mr-1.5">
                      <i className="ri-fire-line text-accent-500 text-xs"></i>
                    </span>
                  )}
                  {topic.name}
                </span>
                <span className="mt-1.5 text-xs text-foreground-400 whitespace-nowrap">
                  {topic.count}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}